<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WIKAUb/image/1.png?1685790893720" alt="This image is the cover for the book Grandma Is Now in Heaven"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grandma Is Now in Heaven
      </h1>
      <p class="bookDescription body article font2">
        <p>Illuminating the bonds of family and the power of love through loss, the author explores the many ways in which remembering a loved one can not only honor their legacy but also connect to a new generation. Despite their physical absence, they live on in our memories.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kasie Kennedy
      </h2>
      
      <p class="authorDescription body article">After the sudden death of her father, Kasie became an unintentional author. She wanted to create a bond between her then twelve-week-old daughter, Quinn and her father, affectionately known as Poppy. She penned a poem that has since been transformed into a short story to help children hold the memory of their loved ones despite their physical absence.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b2f6183